import { memo, useMemo, useRef } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectCommunityJackpotEvents } from '../../../state';
import { getActiveMilestone } from '../../../utils/jackpot';
import { getPrevActiveMilestone } from './JackpotProgress.utils';
import { JackpotProgressProps } from './JackpotProgress.types';
import { Box } from '@bonanza-social/moonlight';
import JackpotProgressMilestones from './JackpotProgressMilestones/JackpotProgressMilestones';
import JackpotProgressHeader from './JackpotProgressHeader/JackpotProgressHeader';
import JackpotProgressFooter from './JackpotProgressFooter/JackpotProgressFooter';
import JackpotProgressBar from './JackpotProgressBar/JackpotProgressBar';

function JackpotProgress({ showLastMilestoneHit }: JackpotProgressProps) {
  const [event] = useSelector(selectCommunityJackpotEvents);
  const eventRef = useRef(event);
  const prevActiveMilestone = useMemo(
    () => getPrevActiveMilestone(eventRef.current),
    [],
  );
  const activeMilestone = useMemo(
    () => getActiveMilestone(eventRef.current) || prevActiveMilestone,
    [prevActiveMilestone],
  );
  const milestoneHit =
    showLastMilestoneHit ||
    (activeMilestone && event.totalContributions >= activeMilestone.threshold);

  return (
    <Box flex={1}>
      <JackpotProgressHeader milestoneHit={milestoneHit} />
      <Box flex={1} marginTop="space-1400" marginBottom="space-400">
        <JackpotProgressMilestones />
        <JackpotProgressBar
          totalContributions={
            showLastMilestoneHit
              ? prevActiveMilestone?.threshold
              : event.totalContributions
          }
          milestones={eventRef.current.milestones}
          activeMilestone={
            showLastMilestoneHit ? prevActiveMilestone : activeMilestone
          }
          prevActiveMilestone={prevActiveMilestone}
          milestoneHit={milestoneHit}
        />
      </Box>
      <JackpotProgressFooter
        showLastMilestoneHit={showLastMilestoneHit}
        prevActiveMilestone={prevActiveMilestone}
        activeMilestone={activeMilestone}
      />
    </Box>
  );
}

export default memo(JackpotProgress);
